import { useEffect, useState } from "react";
import styled from "styled-components";

import * as anchor from "@malloc-protocol/anchor";

import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import {
  awaitTransactionSignatureConfirmation,
  shortenAddress,
} from "./utils/malloc";
import { useStore } from "react-stores";
import LoadingTX from "./components/tx-handler/LoadingTX";
import TableGUI from "./components/tablegui";
import { globalStore } from "./globalStore";
import { constants, MallocSdk, utils } from "@malloc-protocol/sdk";
import { getProvider } from "./utils/anchor";
import { Alert, Snackbar } from "@mui/material";
import { BN } from "@malloc-protocol/anchor";

const ConnectButton = styled(WalletDialogButton)``;

const CounterText = styled.span``; // add your styles here

export interface HomeProps {
  connection: anchor.web3.Connection;
  txTimeout: number;
}

const Home = (props: HomeProps) => {
  const [balance, setBalance] = useState<string>();
  const [isActive, setIsActive] = useState(false); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT

  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const wallet = useWallet();
  const anchorWallet = useAnchorWallet();
  const state = useStore(globalStore);

  const setMallocSdk = () => {
    if (anchorWallet) {
      globalStore.setState({
        ...state,
        malloc: new MallocSdk(
          constants.PIDS.mainnet.MALLOC,
          getProvider(anchorWallet!),
          "mainnet-beta"
        ),
      });
    }
  };

  useEffect(() => {
    setMallocSdk();
  }, []);

  useEffect(() => {
    (async () => {
      if (anchorWallet?.publicKey) {
        const balance = await props.connection.getBalance(
          anchorWallet.publicKey
        );
        const formatted = utils.tokens.toReadableNumber(new BN(balance), 9);
        setBalance(parseFloat(formatted).toFixed(4));
        setMallocSdk();
      }
    })();
  }, [wallet.publicKey]);

  return (
    <main>
      <div className="header">
        <div style={{ display: "flex", justifyContent: "left", gap: "1rem" }}>
          <h1>malloc</h1>
        </div>
        <div style={{ display: "flex", justifyContent: "right", gap: "1rem" }}>
          {/* <ConnectButton>Connect Wallet</ConnectButton> */}
          {wallet.connected && (
            <div>
              <p style={{ marginTop: 0 }}>
                Address: {shortenAddress(wallet.publicKey?.toBase58() || "")}{" "}
                <br />
                Balance: {(balance || 0).toLocaleString()} SOL
              </p>
            </div>
          )}
          {!wallet.connected && <ConnectButton>Connect Wallet</ConnectButton>}
          {/* <a
            href="https://github.com/Lev-Stambler/malloc-solana2"
            target="_blank"
          >
            <i className="bi bi-github"></i>
          </a> */}
          <a href="https://twitter.com/MallocProtocol" target="_blank">
            <i className="bi bi-twitter"></i>
          </a>
          {/* never expires, 1 time use */}
          <a href="https://discord.gg/QTeDHd3Feg" target="_blank">
            <i className="bi bi-discord"></i>
          </a>
          <a href="mailto:mallocprotocol@gmail.com" target="_blank">
            <i className="bi bi-mailbox"></i>
          </a>
          <a href="https://forms.gle/5xLmGcYspJb1dbXP9">
            <i className="bi bi-bug-fill"></i>
          </a>
        </div>
      </div>

      <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>

      <TableGUI connection={props.connection} />
    </main>
  );
};

interface AlertState {
  open: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error" | undefined;
}

const renderCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <CounterText>
      {hours} hours, {minutes} minutes, {seconds} seconds
    </CounterText>
  );
};

export default Home;
